import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";

import MainLayout from "./layouts/MainLayouts";
import Dashboard from "./pages/dashboard";
import UserManagement from "./pages/usermanagement";
import ContentManagement from "./pages/contentmanagement";
import CreatorPerformance from "./pages/revenuepercreator";
import Reports from "./pages/reports";
import SignIn from "./pages/signin";
import ProtectedRoute from "./components/ProtectedRoute";

import { SearchProvider } from "./context/SearchContext";
import "./App.css";
import { ToastContainer } from "react-toastify";

function App() {
  return (
    <>
      <SearchProvider>
        <Routes>
          {/* Public Route */}
          <Route path="/" element={<SignIn />} />

          {/* Protected Routes */}
          <Route
            element={
              <ProtectedRoute>
                <MainLayout />
              </ProtectedRoute>
            }
          >
            <Route path="/dashboard" element={<Dashboard />} />
            <Route path="/users-management" element={<UserManagement />} />
            <Route
              path="/content-management"
              element={<ContentManagement />}
            />
            <Route
              path="/revenue-per-creator"
              element={<CreatorPerformance />}
            />
            <Route path="/reports" element={<Reports />} />
          </Route>

          {/* Redirect unknown routes to login */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </SearchProvider>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        pauseOnHover
        closeOnClick
      />
    </>
  );
}

export default App;
